import { render, staticRenderFns } from "./AppNavmenuleftmedecin.vue?vue&type=template&id=07b73324&"
import script from "./AppNavmenuleftmedecin.vue?vue&type=script&lang=js&"
export * from "./AppNavmenuleftmedecin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports